export default __webpack_public_path__ + "static/media/loginimage.ebb2e6a3.jpeg";